import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-add-new-watchlist-dialog',
  templateUrl: './add-new-watchlist-dialog.component.html',
  styleUrls: ['./add-new-watchlist-dialog.component.scss']
})
export class AddNewWatchlistDialogComponent implements OnInit {

  watchlistName = new FormControl();

  constructor(
    public dialogRef: MatDialogRef<string>,
  ) { }

  ngOnInit(): void {
  }

  cancel() {
    this.dialogRef.close();
  }

  confirm() {
    this.dialogRef.close(this.watchlistName.value);
  }
}
